module.exports = __webpack_public_path__ + "img/ball.e3e1050e.svg";